import Cookies from "js-cookie";
import { BASE_URL } from "./connectionUrl";
const authStaging = Cookies.get("authStaging")
  ? JSON.parse(Cookies.get("authStaging"))
  : null;
const token = authStaging?.token || "";

export const deleteLabReport = async (id) => {
  const url = `${BASE_URL}/api/v1/invoices/remove_item?item_id=${id}`;
  try {
    const res = await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });
    const data = await res.json();
    return data;
  } catch (error) {
    return error;
  }
};

export const deletePurchaseOrder = async (id) => {
  const url = `${BASE_URL}/api/v1/pharmacy/purchase_orders/${id}`;
  try {
    const res = await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });
    const data = await res.json();
    return data;
  } catch (error) {
    return error;
  }
};

export const deleteSupplier = async (id) => {
  const url = `${BASE_URL}/api/v1/pharmacy/suppliers/${id}`;
  try {
    const res = await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });
    const data = await res.json();
    return data;
  } catch (error) {
    return error;
  }
};

export const deleteMedicine = async (id) => {
  const url = `${BASE_URL}/api/v1/pharmacy/medicines/${id}`;
  try {
    const res = await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });
    const data = await res.json();
    return data;
  } catch (error) {
    return error;
  }
};

export const deleteMedicineSalt = async (id) => {
  const url = `${BASE_URL}/api/v1/pharmacy/medicine_salts/${id}`;
  try {
    const res = await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });
    const data = await res.json();
    return data;
  } catch (error) {
    return error;
  }
};

export const deletePharmacy = async (id) => {
  const url = `${BASE_URL}/api/v1/invoices/remove_item?item_id=${id}`;
  try {
    const res = await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });
    const data = await res.json();
    return data;
  } catch (error) {
    return error;
  }
};

export const cancelTest = async (id) => {
  const url = `${BASE_URL}/api/v1/invoices/cancel_test?item_id=${id}`;
  try {
    const res = await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });
    const data = await res.json();
    return data;
  } catch (error) {
    return error;
  }
};

export const deleteMedicineAdmin = async (id) => {
  const url = `${BASE_URL}/api/v1/admin/medicines/${id}`;
  try {
    const res = await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });
    const data = await res.json();
    return data;
  } catch (error) {
    return error;
  }
};

export const deleteDescription = async (id) => {
  const url = `${BASE_URL}/api/v1/admin/medicine_descriptions/${id}`;
  try {
    const res = await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });
    const data = await res.json();
    return data;
  } catch (error) {
    return error;
  }
};

export const deleteShortCode = async (id) => {
  const url = `${BASE_URL}/api/v1/admin/medical_test_shortcodes/${id}`;
  try {
    const res = await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });
    const data = await res.json();
    return data;
  } catch (error) {
    return error;
  }
};

export const treatmentTemplates = async (id) => {
  const url = `${BASE_URL}/api/v1/admin/treatments/${id}`;
  try {
    const res = await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}}`,
      },
    });
    const data = await res.json();
    return data;
  } catch (error) {
    return error;
  }
};

export const deleteDiagnosis = async (id) => {
  const url = `${BASE_URL}/api/v1/admin/diagnosis/${id}`;
  try {
    const res = await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });
    const data = await res.json();
    return data;
  } catch (error) {
    return error;
  }
};

export const deleteSplInst = async (id) => {
  const url = `${BASE_URL}/api/v1/admin/treatments/${id}`;
  try {
    const res = await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}}`,
      },
    });
    const data = await res.json();
    return data;
  } catch (error) {
    return error;
  }
};

export const deleteMedicineRemarks = async (id) => {
  const url = `${BASE_URL}/api/v1/admin/medicine_remarks/${id}`;
  try {
    const res = await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });
    const data = await res.json();
    return data;
  } catch (error) {
    return error;
  }
};

export const deleteFollowUp = async (id) => {
  const url = `${BASE_URL}/api/v1/admin/followup_lists/${id}`;
  try {
    const res = await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });
    const data = await res.json();
    return data;
  } catch (error) {
    return error;
  }
};

export const deleteAiSummaryRecording = async (id) => {
  const url = `${BASE_URL}/api/v1/voices/${id}`;
  try {
    const res = await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });
    const data = await res.json();
    return data;
  } catch (error) {
    return error;
  }
};

export const deleteExternalLabReport = async (id) => {
  const url = `${BASE_URL}/api/v1/medical_test_reports/${id}`;
  try {
    const res = await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });
    const data = await res.json();
    return data;
  } catch (error) {
    return error;
  }
};

export const deleteExternalLabDocument = async (id) => {
  const url = `${BASE_URL}/api/v1/documents/${id}`;
  try {
    const res = await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });
    const data = await res.json();
    return data;
  } catch (error) {
    return error;
  }
};

export const deleteExternalLabreportMultiple = async (ids) => {
  const url = `${BASE_URL}/api/v1/medical_test_reports/destroy_reports/?ids[]=${ids.join("&ids[]=")}`;
  try {
    const res = await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });
    const data = await res.json();
    return data;
  } catch (error) {
    return error;
  }
};

export const deleteExternalMed = async (id) => {
  const url = `${BASE_URL}/api/v1/external_medications/${id}`;
  try {
    const res = await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });
    const data = await res.json();
    return data;
  } catch (error) {
    return error;
  }
};
